import { useRouter } from 'next/router';
import React, { useCallback, useState } from 'react';
import { Button, Icon } from '@pairy/pds-react';

import LinkCopyButton from '@/components/User/_components/common/LinkCopyButton';
import DeleteConfirmModal from '@/components/User/_components/common/DeleteConfirmModal';
import useEditFileClient from '@/hooks/mutations/file/useEditFileClient';
import { TrackingLinkClient } from '@/hooks/queries/client/useClientTrackList';
import DeletionNotice from '@/components/User/_components/common/DeletionNotice';
import useDeleteFileClient from '@/hooks/mutations/file/useDeleteFileClient';
import useFile from '@/hooks/queries/file/useFile';
import { formatKoreanPhoneNumber } from '@/utils/formatPhone';

import * as Styled from './index.styles';
import Client from './Client';

interface Props extends TrackingLinkClient {}

const Box = ({
  id,
  isChecked,
  lastAction,
  like,
  name,
  company,
  phone,
  readCount,
  priorReadCount,
  hashId,
}: Props) => {
  const router = useRouter();
  const fileId = Number(router.query.fileId);

  const { data: fileData } = useFile(
    {
      fileId,
    },
    {
      enabled: Boolean(fileId),
      select: (data) => data.data.data.file,
    },
  );

  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleClickDeleteClientButton = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setIsOpenModal(true);
    },
    [],
  );

  const deleteClientFile = useEditFileClient();

  const { mutate } = useDeleteFileClient();

  const deleteClient = React.useCallback(() => {
    mutate(
      {
        fileId,
        clientId: id,
      },
      {
        onSuccess: () => router.reload(),
      },
    );

    return;
  }, [deleteClientFile, fileId, id, router]);

  const handleClickClient = useCallback(() => {
    router.push(`/user/client/pdf-tracking?clientId=${id}&fileId=${fileId}`);
  }, [fileId, id, router]);

  return (
    <>
      <Client
        id={id}
        name={name}
        company={company}
        phone={phone}
        isChecked={isChecked}
        like={like}
        readCount={readCount}
        priorReadCount={priorReadCount}
        lastAction={lastAction}
        email={null}
        onClick={handleClickClient}
        rightIcon={
          <Styled.BottomButtonWrapper>
            <Button
              variant="zinc_300"
              textVariant="sm-medium"
              radius={4}
              borderLess
              onClick={handleClickDeleteClientButton}
              leftIcon={<Icon icon="ph:trash" size={17} />}
            >
              링크 삭제
            </Button>
            <LinkCopyButton
              hashId={hashId}
              clientId={id}
              id={fileId}
              type="file"
            />
          </Styled.BottomButtonWrapper>
        }
      />
      <DeleteConfirmModal
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        onClick={deleteClient}
        content={
          <DeletionNotice
            clientName={
              name ||
              company ||
              (phone ? formatKoreanPhoneNumber(phone) : '') ||
              ''
            }
            linkName={fileData?.name ?? ''}
          />
        }
      />
    </>
  );
};

export default Box;
